import { Loading3QuartersOutlined } from "@ant-design/icons";
import "./Loader.scss";
import classNames from "classnames";

const styles: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
};

const Loader: React.FC<{ className?: string; message?: string }> = ({
  className,
  message,
}) => {
  return (
    <div className={classNames("icon-container", className)} style={styles}>
      <Loading3QuartersOutlined spin />
      <span>{message || "Chargement en cours..."}</span>
    </div>
  );
};

export default Loader;
